import { createI18n } from 'vue-i18n'
import en from '@/locales/en'

export default createI18n({
    legacy: false,
    locale: 'en',
    missingWarn: import.meta.env.DEV,
    fallbackWarn: false,
    messages: {
        en,
    },
})
